<app-common-modal-form
  header="Re-send email"
  icon="ic-notes-20"
  confirmText="{{btnTextValue}}"
  closeText="Cancel"
  [isLoading]="isLoading"
  (close)="close()"
  (confirm)="resend()"
>
  <div
    class="body-container d-flex flex-column gap-24"
    [formGroup]="form"
  >
    <app-input
      label="Email *"
      formControlName="email"
      [customErrors]="emailValidatorMsg"
    />

    <app-input-phone-number
      label="Phone"
      class="input-mrgn-20"
      formControlName="phone"
    />
  </div>

  @if(showDisclaimer)
  {
      <app-disclaimer
      color="orange"
      icon="ic-info-circle-20">
      {{message}}
    </app-disclaimer>
  }
</app-common-modal-form>
